<template>
  <div>
    <a-modal
      title="高级搜索"
      width="54%"
      :visible="isVisible"
      :destroyOnClose="true"
      @ok="handleOk"
      @cancel="close"
    >
      <div>
        <a-form-model
          ref="formRef"
          :model="advancedEnquiries.dataForm"
          labelAlign="right"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="ID" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                <a-input-number v-model="advancedEnquiries.dataForm.idStart" style="width: 200px;" />&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;
                <a-input-number v-model="advancedEnquiries.dataForm.idEnd" style="width: 200px;" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <div v-for="(item, index) in advancedEnquiries.advancedEnquiries" :key="index">
              <a-col :span="item.layout ? item.layout : 12">
                <a-form-model-item
                  :label="item.label"
                  :labelCol="item.layout ? rowLabel : null"
                  :wrapperCol="item.layout ? rowWrapper : null"
                >
                  <!-- 输入框 -->
                  <div v-if="item.type === 'input'">
                    <a-input
                      v-if="item.defaultModel"
                      v-model="advancedEnquiries[item.modelKey][item.key]"
                      :placeholder="'请输入' + item.label"
                      :allowClear="true"
                    />
                    <a-input
                      v-else
                      v-model="advancedEnquiries.dataForm[item.key]"
                      :placeholder="'请输入' + item.label"
                      :allowClear="true"
                    />
                  </div>
                  <!-- 时间 -->
                  <div v-if="item.type === 'date'">
                    <a-date-picker
                      v-if="item.defaultModel"
                      v-model="advancedEnquiries[item.modelKey][item.key]"
                      placeholder="请选择日期"
                      valueFormat="YYYY-MM-DD"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                    <a-date-picker
                      v-else
                      v-model="advancedEnquiries.dataForm[item.key]"
                      valueFormat="YYYY-MM-DD"
                      placeholder="请选择日期"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                  </div>
                  <!-- 具体时间 -->
                  <div v-if="item.type === 'time'">
                    <a-date-picker
                      v-if="item.defaultModel"
                      v-model="advancedEnquiries[item.modelKey][item.key]"
                      show-time
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      placeholder="请选择时间"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                    <a-date-picker
                      v-else
                      v-model="advancedEnquiries.dataForm[item.key]"
                      show-time
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      placeholder="请选择时间"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                  </div>
                  <div v-if="item.type === 'yearMounth'">
                    <a-month-picker
                      v-if="item.defaultModel"
                      v-model="advancedEnquiries[item.modelKey][item.key]"
                      show-time
                      format="YYYY-MM"
                      valueFormat="YYYY-MM"
                      placeholder="请选择时间"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                    <a-month-picker
                      v-else
                      v-model="advancedEnquiries.dataForm[item.key]"
                      show-time
                      format="YYYY-MM"
                      valueFormat="YYYY-MM"
                      placeholder="请选择时间"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                  </div>
                  <!-- 年 -->
                  <div v-if="item.type === 'year'">
                    <a-date-picker
                      v-if="item.defaultModel"
                      format="YYYY"
                      mode="year"
                      valueFormat="YYYY"
                      inputReadOnly
                      :value="advancedEnquiries[item.modelKey][item.key]"
                      :open="isopen"
                      allowClear
                      @change="(val, mode) => {onChangeDate(val, mode, item.modelKey, item.key, item.defaultModel)}"
                      @openChange="openChange"
                      @panelChange="(val) => {panelChange(val, item.modelKey, item.key, item.defaultModel)}"
                      placeholder="请选择年份"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                    <a-date-picker
                      v-else
                      format="YYYY"
                      mode="year"
                      valueFormat="YYYY"
                      inputReadOnly
                      :value="advancedEnquiries.dataForm[item.key]"
                      :open="isopen"
                      allowClear
                      @change="(val, mode) => {onChangeDate(val, mode, item.modelKey, item.key, item.defaultModel)}"
                      @openChange="openChange"
                      @panelChange="(val) => {panelChange(val, item.modelKey, item.key, item.defaultModel)}"
                      placeholder="请选择年份"
                      class="filter-item search-item"
                      style="width: 100%;"
                    />
                  </div>
                  <!-- 下拉选择框 -->
                  <div v-if="item.type === 'select'">
                    <a-select
                      v-if="item.defaultModel"
                      show-search
                      v-model="advancedEnquiries[item.modelKey][item.key]"
                      :placeholder="'请选择' + item.label"
                      style="width: 100%"
                      :allowClear="true"
                    >
                      <a-select-option
                        v-for="item1 in item.content"
                        :key="item.keyLabel ? item1[item.keyLabel[0]] : item1.value"
                        :value="item.keyLabel ? item1[item.keyLabel[0]] : item1.value"
                      >
                        {{ item.keyLabel ?
                        item1[item.keyLabel[1]] : item1.label }}
                      </a-select-option>
                    </a-select>
                    <a-select
                      v-else
                      show-search
                      v-model="advancedEnquiries.dataForm[item.key]"
                      :placeholder="'请选择' + item.label"
                      style="width: 100%"
                      :allowClear="true"
                    >
                      <a-select-option
                        v-for="item1 in item.content"
                        :key="item.keyLabel ? item1[item.keyLabel[0]] : item1.value"
                        :value="item.keyLabel ? item1[item.keyLabel[0]] : item1.value"
                      >
                        {{ item.keyLabel ?
                        item1[item.keyLabel[1]] : item1.label }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <!-- 单选 -->
                  <div v-if="item.type === 'radio'">
                    <a-radio-group
                      v-if="item.defaultModel"
                      name="radioGroup"
                      v-model="advancedEnquiries[item.modelKey][item.key]"
                      :default-value="''"
                      style="width: 100%;"
                    >
                      <a-radio
                        v-for="item1 in item.content"
                        :key="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                        :value="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                      >
                        {{ item1[item.keyLabel ?
                        item.keyLabel[0] : 'label'] }}
                      </a-radio>
                    </a-radio-group>
                    <a-radio-group
                      v-else
                      name="radioGroup"
                      v-model="advancedEnquiries.dataForm[item.key]"
                      :default-value="''"
                      style="width: 100%;"
                    >
                      <a-radio
                        v-for="item1 in item.content"
                        :key="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                        :value="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                      >
                        {{ item1[item.keyLabel ?
                        item.keyLabel[0] : 'label'] }}
                      </a-radio>
                    </a-radio-group>
                  </div>
                  <!-- 多选 -->
                  <div v-if="item.type === 'checkbox'">
                    <div v-if="item.defaultModel">
                      <a-checkbox
                        :checked="checkedAll"
                        :value="''"
                        @change="(e) => { changeAll(e, item) }"
                      >全部</a-checkbox>
                      <a-checkbox-group
                        name="radioGroup"
                        v-model="advancedEnquiries[item.modelKey][item.key]"
                        style="margin-right: 20px;"
                      >
                        <a-checkbox
                          v-for="item1 in item.content"
                          :key="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                          :value="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                        >
                          {{ item1[item.keyLabel ?
                          item.keyLabel[0] : 'label'] }}
                        </a-checkbox>
                      </a-checkbox-group>
                    </div>
                    <div v-else>
                      <a-checkbox
                        :checked="checkedAll"
                        :value="''"
                        @change="(e) => { changeAll(e, item) }"
                      >全部</a-checkbox>
                      <a-checkbox-group
                        name="radioGroup"
                        v-model="advancedEnquiries.dataForm[item.key]"
                        style="margin-right: 20px;"
                      >
                        <a-checkbox
                          v-for="item1 in item.content"
                          :key="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                          :value="item1[item.keyLabel ? item.keyLabel[1] : 'value']"
                        >
                          {{ item1[item.keyLabel ?
                          item.keyLabel[0] : 'label'] }}
                        </a-checkbox>
                      </a-checkbox-group>
                    </div>
                  </div>
                  <!-- 数字输入框  区间 -->
                  <div v-if="item.type === 'numberInput'">
                    <div v-if="item.defaultModel">
                      <a-input-number
                        v-model="advancedEnquiries[item.modelKey][item.key[0]]"
                        style="width: 200px;"
                      />&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;
                      <a-input-number
                        v-model="advancedEnquiries[item.modelKey][item.key[1]]"
                        style="width: 200px;"
                      />
                    </div>
                    <div v-else>
                      <a-input-number
                        v-model="advancedEnquiries.dataForm[item.key[0]]"
                        style="width: 200px;"
                      />&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;
                      <a-input-number
                        v-model="advancedEnquiries.dataForm[item.key[1]]"
                        style="width: 200px;"
                      />
                    </div>
                  </div>
                  <!-- 人选选择   返id 和 name -->
                  <div v-if="item.type === 'person'">
                    <p class="choosePerson" @click="openPerson('user', item.isOnce, item)">
                      {{
                      advancedEnquiries.dataForm[item.key + 'Name'] || '点击选择抄送人' }}
                    </p>
                    <!-- <p v-if="item.defaultModel" class="choosePerson" @click="openPerson(item.key, item.isOnce, item.defaultModel, item.modelKey)">{{ advancedEnquiries[item.modelKey][item.key + 'Name'] || '请选择' + item.label }}</p>
                    <p v-else class="choosePerson" @click="openPerson(item.key, item.isOnce, item.defaultModel, item.modelKey)">{{ advancedEnquiries.dataForm[item.key + 'Name'] || '请选择' + item.label }}</p>-->
                  </div>
                  <!-- <p v-if="item.type === 'person'" class="choosePerson" @click="openPerson(item.key, item.isOnce, item.defaultModel, item.modelKey)">{{ advancedEnquiries.dataForm[item.key + 'Name'] || advancedEnquiries[item.modelKey][item.key + 'Name'] || '请选择' + item.label }}</p> -->
                  <!-- 部门选择  返 id、name -->
                  <div v-if="item.type === 'dept'">
                    <a-tree-select
                      v-if="item.defaultModel"
                      v-model="advancedEnquiries[item.modelKey][item.key + 'Name']"
                      :allowClear="true"
                      tree-data-simple-mode
                      placeholder="选择部门"
                      :dropdownStyle="{ maxHeight: '220px', overflow: 'auto' }"
                      :treeData="deptTreeData"
                      v-decorator="['deptId', { rules: [{ required: true, message: '请选择使用部门' }] }]"
                      :load-data="getDept"
                      @change="(deptId, deptIdList, event) => { deptIdChange(deptId, deptIdList, event, item.key, item.defaultModel, item.modelKey) }"
                    ></a-tree-select>
                    <a-tree-select
                      v-else
                      v-model="advancedEnquiries.dataForm[item.key + 'Name']"
                      :allowClear="true"
                      tree-data-simple-mode
                      placeholder="选择部门"
                      :dropdownStyle="{ maxHeight: '220px', overflow: 'auto' }"
                      :treeData="deptTreeData"
                      v-decorator="['deptId', { rules: [{ required: true, message: '请选择使用部门' }] }]"
                      :load-data="getDept"
                      @change="(a, b, c) => { deptIdChange(a, b, c, item.key, item.defaultModel, item.modelKey) }"
                    ></a-tree-select>
                  </div>
                  <!-- 审核状态 -->
                  <!-- <a-radio-group name="radioGroup" v-if="item.type === 'checkStatus'" v-model="advancedEnquiries.checkStatus" :default-value="''" style="margin-right: 20px;">
                    <a-radio value="">全部</a-radio>
                    <a-radio v-for="(item, index) in checkStatusList" :key="index" :value="item.label">{{ item.value }}
                    </a-radio>
                  </a-radio-group>-->
                  <!-- 对应项目 -->
                  <div v-if="item.type === 'project'">
                    <a-input
                      v-if="item.defaultModel"
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries[item.modelKey].projectName"
                      @click="openModal('project', item.defaultModel, item.modelKey, item.key)"
                      placeholder="点击选择对应的项目"
                    >
                      <a-icon
                        v-show="advancedEnquiries[item.modelKey].projectName"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearProject(true, item.modelKey)"
                      />
                    </a-input>
                    <a-input
                      v-else
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries.dataForm.projectName"
                      @click="openModal('project', item.defaultModel, item.modelKey, item.key)"
                      placeholder="点击选择对应的项目"
                    >
                      <a-icon
                        v-show="advancedEnquiries.dataForm.projectName"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearProject(false, item.modelKey)"
                      />
                    </a-input>
                  </div>
                  <!-- 转入转出项目 -->
                  <div v-if="item.type === 'projects'">
                    <a-input
                      v-if="item.defaultModel"
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries[item.modelKey][item.key + 'Name']"
                      @click="openModal('projects', item.defaultModel, item.modelKey, item.key, null, true)"
                      placeholder="点击选择对应的项目"
                    >
                      <a-icon
                        v-show="advancedEnquiries[item.modelKey][item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearProjects(true, item.modelKey, item.key)"
                      />
                    </a-input>
                    <a-input
                      v-else
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries.dataForm[item.key + 'Name']"
                      @click="openModal('projects', item.defaultModel, item.modelKey, item.key, null, true)"
                      placeholder="点击选择对应的项目"
                    >
                      <a-icon
                        v-show="advancedEnquiries.dataForm[item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearProjects(false, item.modelKey, item.key)"
                      />
                    </a-input>
                  </div>
                  <!-- <a-input v-if="item.type === 'project'" read-only class="choosePerson inputClass" v-model="advancedEnquiries.dataForm.projectName" @click="openModal('project', item.defaultModel, item.modelKey, item.key)" placeholder="点击选择对应的项目" /> -->
                  <!-- 客户/供应商 -->
                  <div v-if="item.type === 'customer'">
                    <a-input
                      v-if="item.defaultModel"
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries[item.modelKey][item.key + 'Name']"
                      @click="openModal('customer', item.defaultModel, item.modelKey, item.key, item.all)"
                      placeholder="点击选择对应的客户/供应商"
                    >
                      <a-icon
                        v-show="advancedEnquiries[item.modelKey][item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(true, item.modelKey, item.key)"
                      />
                    </a-input>
                    <a-input
                      v-else
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries.dataForm[item.key + 'Name']"
                      @click="openModal('customer', item.defaultModel, item.modelKey, item.key, item.all)"
                      placeholder="点击选择对应的客户/供应商"
                    >
                      <a-icon
                        v-show="advancedEnquiries.dataForm[item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(false, item.modelKey, item.key)"
                      />
                    </a-input>
                  </div>
                  <!-- 客户 -->
                  <div v-if="item.type === 'customers'">
                    <a-input
                      v-if="item.defaultModel"
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries[item.modelKey][item.key + 'Name']"
                      @click="openModal('customers', item.defaultModel, item.modelKey, item.key, item.all)"
                      placeholder="点击选择对应的客户"
                    >
                      <a-icon
                        v-show="advancedEnquiries[item.modelKey][item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(true, item.modelKey, item.key)"
                      />
                    </a-input>
                    <a-input
                      v-else
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries.dataForm[item.key + 'Name']"
                      @click="openModal('customers', item.defaultModel, item.modelKey, item.key, item.all)"
                      placeholder="点击选择对应的客户"
                    >
                      <a-icon
                        v-show="advancedEnquiries.dataForm[item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(false, item.modelKey, item.key)"
                      />
                    </a-input>
                  </div>
                  <!-- <a-input v-if="item.type === 'customer'" read-only class="choosePerson inputClass" v-model="advancedEnquiries.dataForm.customerName" @click="openModal('customer',item.defaultModel, item.modelKey, item.key, item.all)" placeholder="点击选择对应的对应客户/供应商" /> -->
                  <!-- 供应商 -->
                  <div v-if="item.type === 'supplier'">
                    <a-input
                      v-if="item.defaultModel"
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries[item.modelKey][item.key + 'Name']"
                      @click="openModal('supplier', item.defaultModel, item.modelKey, item.key)"
                      placeholder="点击选择对应的供应商"
                    >
                      <a-icon
                        v-show="advancedEnquiries[item.modelKey][item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(true, item.modelKey, item.key)"
                      />
                    </a-input>
                    <a-input
                      v-else
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries.dataForm[item.key + 'Name']"
                      @click="openModal('supplier', item.defaultModel, item.modelKey, item.key)"
                      placeholder="点击选择对应的供应商"
                    >
                      <a-icon
                        v-show="advancedEnquiries.dataForm[item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(false, item.modelKey, item.key)"
                      />
                    </a-input>
                  </div>
                  <!-- 离职补偿联系人 -->
                  <div v-if="item.type === 'resignationsLinkName'">
                    <a-input
                      v-if="item.defaultModel"
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries[item.modelKey][item.key + 'Name']"
                      @click="openModal('resignationsLinkName', item.defaultModel, item.modelKey, item.key)"
                      placeholder="点击选择对应的离职补偿人员"
                    >
                      <a-icon
                        v-show="advancedEnquiries[item.modelKey][item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(true, item.modelKey, item.key)"
                      />
                    </a-input>
                    <a-input
                      v-else
                      read-only
                      class="inputClass"
                      v-model="advancedEnquiries.dataForm[item.key + 'Name']"
                      @click="openModal('resignationsLinkName', item.defaultModel, item.modelKey, item.key)"
                      placeholder="点击选择对应的离职补偿人员"
                    >
                      <a-icon
                        v-show="advancedEnquiries.dataForm[item.key + 'Name']"
                        slot="suffix"
                        type="close-circle"
                        style="cursor: pointer;"
                        @click="clearCustomer(false, item.modelKey, item.key)"
                      />
                    </a-input>
                  </div>
                  <!-- <a-input v-if="item.type === 'supplier'" read-only class="choosePerson inputClass" v-model="advancedEnquiries.dataForm.customerName" @click="openModal('supplier', item.defaultModel, item.modelKey, item.key)" placeholder="点击选择对应的对应供应商" /> -->
                </a-form-model-item>
              </a-col>
            </div>
          </a-row>
        </a-form-model>
      </div>
      <template #footer>
        <a-button @click="close" style="background-color:#F2F2F2">取消</a-button>
        <!-- <a-button  type="primary" @click="handleOk(0)">查询</a-button> -->
        <a-button @click="handleOk(1)" style="background-color:#52c41a;color:#fff;">查询并保存</a-button>
      </template>
      <publicDialog
        :title="publicDia.title"
        :dialog-visible="publicDia.visible"
        :component-name="publicDia.comName"
        @logSuccess="publicDialogSucc"
        @cancel="handleClose"
      />
      <personnel
        :visible="personVisible"
        :chooseData="chooseData"
        :isOnce="isOnce"
        @close="personClose"
        @success="personSuccess"
      />
      <customerDialog
        :dialogVisible="customerVisible"
        @logSuccess="customerSuccess"
        @cancel="customerCancel"
        :title="titles"
      />
    </a-modal>
  </div>
</template>

<script>
import publicDialog from '@/components/modelDialog/publicDialog.vue'
import personnel from '@/components/personnel'
import customerDialog from '@/components/modelDialog/customerDialog'
import moment from 'moment'
// import { EventBus } from '@/utils/EventBus.js';
export default {
  components: { publicDialog, personnel, customerDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  inject: ['advancedEnquiries'],
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  provide () {
    return {
      type: this.types,
      customTyped: this
    }
  },
  data () {
    return {
      publicDia: {
        title: '',
        visible: false,
        comName: ''
      },
      dataConm: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      personVisible: false,
      isOnce: false,
      key: '',
      defaultModel: true,
      openPersonType: '',
      chooseData: {},
      deptTreeData: [],
      form: {},
      checkedAll: false,
      types: true,
      checkStatusList: [],
      titles: '选择客户/供应商',
      customerVisible: false,
      proTrans: false,
      isopen: false // 年份选择
    }
  },
  beforeMount () {
    this.checkStatusList = this.$store.state.account.dictData.checkStatusList
  },
  methods: {
    /**
     *
     * @param type
     * @param defaultModel
     * @param modelKey
     * @param key
     * @param hount
     * @param proTrans 结转项目中的转入转出项目需要
     */
    openModal (type, defaultModel, modelKey, key, hount, proTrans = false) {
      this.defaultModel = defaultModel
      this.modelKey = modelKey
      this.key = key
      this.proTrans = proTrans
      if (type === 'customer') {
        this.customerVisible = true
        this.types = hount
        this.$forceUpdate()
      } else if (type === 'project') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
      } else if (type === 'supplier') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应供应商'
        this.publicDia.comName = 'purchase/supplier'
      } else if (type === 'customers') {
        this.types = hount
        this.publicDia.visible = true
        this.publicDia.title = '选择对应客户'
        this.publicDia.comName = 'customerManage'
      } else if (type === 'projects') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
      } else if (type === 'resignationsLinkName') {
        this.publicDia.visible = true
        this.publicDia.title = '点击选择对应离职补偿人员'
        this.publicDia.comName = 'customerManage/resignationsCompensation'
      }
    },
    publicDialogSucc (data, typeVal) {
      if (typeVal === 'projectManage') {
        if (this.proTrans) {
          if (this.defaultModel) {
            this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Name', data.subject)
            this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Id', data.id)
          } else {
            this.$set(this.advancedEnquiries.dataForm, this.key + 'Name', data.subject)
            this.$set(this.advancedEnquiries.dataForm, this.key + 'Id', data.id)
          }
        } else {
          if (this.defaultModel) {
            this.$set(this.advancedEnquiries[this.modelKey], 'projectName', data.subject)
            this.$set(this.advancedEnquiries[this.modelKey], 'projectId', data.id)
          } else {
            this.$set(this.advancedEnquiries.dataForm, 'projectName', data.subject)
            this.$set(this.advancedEnquiries.dataForm, 'projectId', data.id)
          }
        }
      } else if (typeVal === 'purchase/supplier') {
        // console.log('data =>', data)
        if (this.defaultModel) {
          this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Name', data.companyName)
          this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Id', data.id)
        } else {
          this.$set(this.advancedEnquiries.dataForm, this.key + 'Name', data.companyName)
          this.$set(this.advancedEnquiries.dataForm, this.key + 'Id', data.id)
        }
      } else if (typeVal === 'customerManage/resignationsCompensation') {
        // console.log('data =>', data)
        if (this.defaultModel) {
          this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Name', data.companyName)
          this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Id', data.id)
        } else {
          this.$set(this.advancedEnquiries.dataForm, this.key + 'Name', data.companyName)
          this.$set(this.advancedEnquiries.dataForm, this.key + 'Id', data.id)
        }
      } else if (typeVal === 'customerManage') {
        // console.log('data =>', data)
        if (this.defaultModel) {
          this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Name', data.companyName)
          this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Id', data.id)
        } else {
          this.$set(this.advancedEnquiries.dataForm, this.key + 'Name', data.companyName)
          this.$set(this.advancedEnquiries.dataForm, this.key + 'Id', data.id)
        }
        // if (this.defaultModel) {
        //   this.$set(this.advancedEnquiries[this.modelKey], 'customerId', data.id)
        //   this.$set(this.advancedEnquiries[this.modelKey], 'customerName', data.companyName)
        // } else {
        //   this.$set(this.advancedEnquiries.dataForm, 'customerId', data.id)
        //   this.$set(this.advancedEnquiries.dataForm, 'customerName', data.companyName)
        // }
      }
      this.resetDialogData()
    },
    clearProject (model, modelKey) {
      if (model) {
        this.$set(this.advancedEnquiries[modelKey], 'projectName', '')
        this.$set(this.advancedEnquiries[modelKey], 'projectId', '')
      } else {
        this.$set(this.advancedEnquiries.dataForm, 'projectName', '')
        this.$set(this.advancedEnquiries.dataForm, 'projectId', '')
      }
    },
    clearProjects (model, modelKey, key) {
      // console.log(model, modelKey, key)
      if (model) {
        this.$set(this.advancedEnquiries[modelKey], key + 'Name', '')
        this.$set(this.advancedEnquiries[modelKey], key + 'Id', '')
      } else {
        this.$set(this.advancedEnquiries.dataForm, key + 'Name', '')
        this.$set(this.advancedEnquiries.dataForm, key + 'Id', '')
      }
    },
    clearCustomer (model, modelKey, key) {
      // console.log(model, modelKey, key)
      if (model) {
        // this.$set(this.advancedEnquiries[modelKey], key + 'Name', '')
        // this.$set(this.advancedEnquiries[modelKey], key + 'Id', '')
        if (key === 'mainCustomer') {
          // console.log(key)
          this.$set(this.advancedEnquiries[modelKey], key, '')
          this.$set(this.advancedEnquiries[modelKey], key + 'Id', '')
          this.$set(this.advancedEnquiries[modelKey], key + 'Name', '')
          this.$set(this.advancedEnquiries[modelKey], 'customerName', '')
        } else {
          this.$set(this.advancedEnquiries[modelKey], key + 'Name', '')
          this.$set(this.advancedEnquiries[modelKey], key + 'Id', '')
        }
      } else {
        this.$set(this.advancedEnquiries.dataForm, key + 'Name', '')
        this.$set(this.advancedEnquiries.dataForm, key + 'Id', '')
      }
    },
    onChangeDate (val, mode, modelKey, key, defaultModel) {
      if (defaultModel) {
        this.$set(this.advancedEnquiries[modelKey], key, mode)
      } else {
        this.$set(this.advancedEnquiries.dataForm, key, mode)
      }
    },
    // 使用openChange事件控制日期下拉面板显示与收起
    openChange (isopen) {
      if (isopen) {
        this.isopen = true
      } else {
        this.isopen = false
      }
    },
    // 使用panelChange事件控制选中年份的方法
    panelChange (value, modelKey, key, defaultModel) {
      // 用monent格式化时间为年，格式化为4位字符串，如果有需要传递数据时为字符串可以这样单独格式化为一份数据
      if (defaultModel) {
        this.$set(this.advancedEnquiries[modelKey], key, moment(value).format('YYYY') + '年')
      } else {
        this.$set(this.advancedEnquiries.dataForm, key, moment(value).format('YYYY') + '年')
      }
      this.isopen = false
    },
    getDept (treeNode) {
      if (treeNode) {
        return new Promise(resolve => {
          setTimeout(() => {
            this.$get('/dept/queryDeptChile', { prentId: treeNode.dataRef.id }).then((r) => {
              let newData = r.data.data
              newData.forEach(t => {
                this.deptTreeData.push(
                  { id: t.deptId, pId: t.parentId, value: t.deptId, title: t.deptName }
                )
              })
            })
            resolve()
          }, 300)
        })
      } else {
        this.$get('/dept/queryDeptChile').then((r) => {
          let newData = r.data.data
          newData.forEach(t => {
            this.deptTreeData.push(
              { id: t.deptId, pId: t.parentId, value: t.deptId, title: t.deptName }
            )
          })
        })
      }
    },
    deptIdChange (deptId, deptIdList, event, key, defaultModel, modelKey) {
      if (defaultModel) {
        let msg = this.advancedEnquiries[modelKey]
        this.$set(msg, key + 'Id', deptId)
        this.$set(msg, key + 'Name', deptIdList[0])
        // this.advancedEnquiries[this.modelKey][]
        // this.$set(msg, this.openPersonType + 'Name', username)
      } else {
        let msg = this.advancedEnquiries.dataForm
        this.$set(msg, key + 'Id', deptId)
        this.$set(msg, key + 'Name', deptIdList[0])
      }
      // this.form.deptId = e
      // this.form.deptName = a[0]
    },
    customerSuccess (data) {
      // if (this.defaultModel) {
      //   this.$set(this.advancedEnquiries[this.modelKey], 'customerId', data.id)
      //   this.$set(this.advancedEnquiries[this.modelKey], 'customerName', data.companyName)
      // } else {
      //   this.$set(this.advancedEnquiries.dataForm, 'customerId', data.id)
      //   this.$set(this.advancedEnquiries.dataForm, 'customerName', data.companyName)
      // }
      if (this.defaultModel) {
        this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Name', data.companyName)
        this.$set(this.advancedEnquiries[this.modelKey], this.key + 'Id', data.id)
      } else {
        this.$set(this.advancedEnquiries.dataForm, this.key + 'Name', data.companyName)
        this.$set(this.advancedEnquiries.dataForm, this.key + 'Id', data.id)
      }
      this.customerVisible = false
    },
    customerCancel () {
      this.customerVisible = false
    },
    openPerson (type, isOnce, item) {
      this.isOnce = isOnce
      this.dataConm = item
      this.personVisible = true
      // this.defaultModel = defaultModel
      this.chooseData = { userId: this.form[type + 'Id'], userName: this.form[type + 'Name'], roleId: this.form.checkRoleId, roleName: this.form.checkRoleName }
    },
    personSuccess (data, type) {
      var username, userId
      // 单选 和 多选 人员数据
      if (type === 'checkType') {
        data.forEach(item => {
          if (!username) {
            username = item.username
            userId = item.userId
          } else {
            username += ',' + item.username
            userId += ',' + item.userId
          }
        })
      } else if (type === 'radioType') {
        username = data.username
        userId = data.userId
      }
      this.advancedEnquiries.dataForm[this.dataConm.key + 'Name'] = username
      this.advancedEnquiries.dataForm[this.dataConm.key + 'Id'] = userId
      // if (this.defaultModel) {
      //   let msg = this.advancedEnquiries[this.modelKey]
      //   this.$set(msg, this.openPersonType + 'Id', userId)
      //   this.$set(msg, this.openPersonType + 'Name', username)
      //   // msg[this.openPersonType + 'Id'] = userId
      //   // msg[this.openPersonType + 'Name'] = username
      // } else {
      //   let msg = this.advancedEnquiries.dataForm
      //   msg[this.openPersonType + 'Id'] = userId
      //   msg[this.openPersonType + 'Name'] = username
      // }
      this.personVisible = false
    },
    handleOk (value) {
      if (value === 0) {
        this.$emit('save')
      } else {
        this.$emit('success')
      }
      this.restForm()
    },
    checkboxChange (e, item) {
      if (item.defaultModel) {
        if (e[e.length - 1 === '']) {
          this.$set(this.advancedEnquiries[this.modelKey], item.key, e.splice(1, e.length - 1))
          // e = e.splice(1, e.length - 1)
        }
      }
    },
    changeAll (e, item) {
      this.checkedAll = e.target.checked
      this.advancedEnquiries.checkedAll = e.target.checked
      if (item.defaultModel) {
        if (this.checkedAll) {
          item.content.forEach(item1 => {
            this.advancedEnquiries[item.modelKey][item.key].push(item1.label)
          })
        } else {
          this.advancedEnquiries[item.modelKey][item.key].length = 0
        }
      } else {
        if (this.checkedAll) {
          item.content.forEach(item1 => {
            this.advancedEnquiries.dataForm[item.key].push(item1.label)
          })
        } else {
          this.advancedEnquiries.dataForm[item.key].length = 0
        }
      }
    },
    close () {
      this.$emit('close')
      this.restForm()
      this.advancedEnquiries.dataForm = {}
    },
    restForm () {
      this.form = {}
      this.deptTreeData = []
    },
    resetDialogData () {
      this.publicDia.visible = false
    },
    handleClose () {
      this.publicDia.visible = false
    },
    personClose () {
      this.personVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.inputClass {
  cursor: pointer;
}

/deep/ .ant-input-affix-wrapper .ant-input-suffix {
  display: none;
}

/deep/ .ant-input-affix-wrapper:hover {
  .ant-input-suffix {
    display: flex;
    z-index: 999;
  }
}
</style>
<!--
  defaultModel: true,     是否同步外面的查询
  modelKey: 'character',     v-nodel 绑定外面的对象名
 -->
<!-- advancedEnquiries: [
输入框
{
  type: 'input',
  label: '所有者',
  key: 'payOwner'
},
时间
{
  type: 'date',
  label: '付款开始日期',
  key: 'payDateStart'
},
{
  type: 'date',
  label: '付款结束日期',
  key: 'payDateEnd'
},
下拉框
{
  type: 'select',
  label: '期次',
  key: 'period',
  keyLabel: ['label1', 'value1'],    不传keyLabel 默认key:label value:value  keyLabel[0]-key   keyLabel[1]-value
  content: [
    {label1: '1', value1: 1},
    {label1: '2', value1: 2},
    {label1: '3', value1: 3},
    {label1: '4', value1: 4},
    {label1: '5', value1: 5},
    {label1: '6', value1: 6},
    {label1: '7', value1: 7},
    {label1: '8', value1: 8},
    {label1: '9', value1: 9},
    {label1: '10', value1: 10},
    {label1: '11', value1: 11},
    {label1: '12', value1: 12}
  ]
},
{
  type: 'checkbox',
  label: '期次',
  layout: 24,
  key: 'periodd',
  content: [
    {label: '1', value: 11},
    {label: '2', value: 22},
    {label: '3', value: 33},
    {label: '4', value: 44},
    {label: '5', value: 55},
    {label: '6', value: 66},
    {label: '7', value: 77}
  ]
},
单选框
{
  type: 'radio',
  label: '收票状态',
  layout: 24,
  key: 'payInvoice',
  content: [
    {label: '全部', value: ''},
    {label: '未收', value: 0},
    {label: '已收', value: 1},
    {label: '无需收票', value: 2}
  ]
},
数字输入框
{
  type: 'numberInput',
  label: '金额',
  layout: 24,
  key: ['payMoney1', 'payMoney2']
},
选人的
{
  type: 'person',
  isOnce: true,    true 单选    false多选
  label: '所有者',
  key: 'payOwner'
},
选部门
{
  type: 'dept',
  label: '部门',
  key: 'dept'
},
{
  type: 'checkStatus',
  label: '审核状态',
  layout: 24,
  key: 'checkStatus'
},
选项目
{
  type: 'project',
  label: '对应项目',
  layout: 24,
  key: 'project'
},
选客户供应商全部   true全部  false 客户
{
  type: 'customer',
  label: '对应客户/供应商',
  all: true,
  layout: 24,
  key: 'customer'
},
选供应商
{
  type: 'supplier',
  label: '对应供应商',
  layout: 24,
  key: 'supplier'
}
], -->



// WEBPACK FOOTER //
// src/components/advancedSearch/popUp.vue